<template lang="pug">
.theme-toggle-container
  aiq-tooltip(placement="bottom"
              effect="dark"
              :content="isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
              :show-after="500")
    aiq-button.theme-toggle(@click="toggleTheme" type="text")
      font-awesome-icon.theme-icon(:icon="isDarkMode ? 'sun' : 'moon'"
                                   :class="{'dark': isDarkMode, 'light': !isDarkMode}")
</template>

<script>
export default {
  name: 'ThemeToggle',
  data() {
    return {
      isDarkMode: false,
    };
  },
  mounted() {
    // Initialize theme from localStorage or system preference
    this.initializeTheme();
  },
  methods: {
    initializeTheme() {
      // Check localStorage first
      const savedTheme = localStorage.getItem('aiq-theme');
      if (savedTheme) {
        this.isDarkMode = savedTheme === 'dark';
      } else {
        // Check system preference
        this.isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      }
      this.applyTheme();
    },
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      this.applyTheme();
      this.saveThemePreference();
    },
    applyTheme() {
      const theme = this.isDarkMode ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', theme);

      // Emit theme change event for other components that might need it
      this.$emit('theme-changed', theme);

      // Update global store if available
      /*
      if (this.$store) {
        this.$store.dispatch('settings/setTheme', theme).catch(() => {
        });
      }
      */
    },
    saveThemePreference() {
      const theme = this.isDarkMode ? 'dark' : 'light';
      localStorage.setItem('aiq-theme', theme);
    },
  },
};
</script>

<style lang="scss" scoped>
.theme-toggle-container {
  display: flex;
  align-items: center;
  height: 100%;

  .theme-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    height: 100%;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 1;
      background: transparent;
    }

    .theme-icon {
      width: 20px;
      height: 20px;
      transition: all 0.3s ease;

      &.light {
        color: rgba(255, 255, 255, 0.75);

        &:hover {
          color: #FFD700;
          opacity: 1;
        }
      }

      &.dark {
        color: rgba(255, 255, 255, 0.75);

        &:hover {
          color: #87CEEB;
          opacity: 1;
        }
      }
    }
  }
}
</style>
